import { ChipSelect } from "./ChipSelect";
import { Checkbox } from "@/components/ui/checkbox";

const KITCHEN_OPTIONS = [
  { value: "yes", label: "Separate Kitchen" },
  { value: "no", label: "Open Plan" },
];

// House features
const HOUSE_FEATURES = [
  { value: "garage", label: "Garage" },
  { value: "loft", label: "Loft Space" },
  { value: "conservatory", label: "Conservatory" },
  { value: "garden", label: "Garden" },
  { value: "none", label: "None" },
];

// Flat/Apartment features
const FLAT_FEATURES = [
  { value: "balcony", label: "Balcony" },
  { value: "communal_garden", label: "Communal Garden" },
  { value: "parking", label: "Parking Space" },
  { value: "storage", label: "Storage Unit" },
  { value: "none", label: "None" },
];

export function LayoutFeaturesScreen({ data, onChange }) {
  const updateField = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const isFlat = data.dwelling_type === "flat";
  const featureOptions = isFlat ? FLAT_FEATURES : HOUSE_FEATURES;

  return (
    <div className="space-y-6">
      {/* Kitchen Layout */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Kitchen Layout
        </label>
        <ChipSelect
          options={KITCHEN_OPTIONS}
          value={data.separate_kitchen}
          onChange={(v) => updateField("separate_kitchen", v)}
          columns={2}
        />
      </div>

      {/* Layout Characteristics */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Layout Characteristics
        </label>
        <div className="space-y-3">
          <label className="flex items-center gap-3 p-3 rounded-xl bg-white/5 border border-white/10 cursor-pointer hover:bg-white/10 transition-colors">
            <Checkbox
              checked={data.wide_hallways === "yes"}
              onCheckedChange={(checked) => updateField("wide_hallways", checked ? "yes" : "no")}
              className="border-white/30 data-[state=checked]:bg-cipher-green data-[state=checked]:border-cipher-green"
            />
            <div>
              <span className="text-sm font-medium text-white">Wide hallways</span>
              <span className="text-xs text-white/40 ml-2">(over 1m)</span>
            </div>
          </label>
          <label className="flex items-center gap-3 p-3 rounded-xl bg-white/5 border border-white/10 cursor-pointer hover:bg-white/10 transition-colors">
            <Checkbox
              checked={data.layout_changed === "yes"}
              onCheckedChange={(checked) => updateField("layout_changed", checked ? "yes" : "no")}
              className="border-white/30 data-[state=checked]:bg-cipher-green data-[state=checked]:border-cipher-green"
            />
            <div>
              <span className="text-sm font-medium text-white">Layout modified</span>
              <span className="text-xs text-white/40 ml-2">(since built)</span>
            </div>
          </label>
        </div>
      </div>

      {/* Features */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Features <span className="text-white/30 font-normal">(select all that apply)</span>
        </label>
        <ChipSelect
          options={featureOptions}
          value={data.features}
          onChange={(v) => updateField("features", v)}
          multiple={true}
          columns={2}
        />
      </div>
    </div>
  );
}

export function isLayoutFeaturesComplete(data) {
  return (
    data.separate_kitchen &&
    data.wide_hallways &&
    data.layout_changed &&
    Array.isArray(data.features) && data.features.length > 0
  );
}
